/**
 * SeatManagementRepository
 * 좌석 관리 API 호출 레이어
 */
import type { SeatActionType } from '../models/SeatManagement';

/**
 * SeatManagementRepository 클래스
 * 좌석 관리 관련 API 호출 담당
 */
export class SeatManagementRepository {
  /**
   * 좌석 상태 변경 (Owner Action)
   */
  async updateSeatStatus(
    seatId: string,
    actionType: SeatActionType,
    reason?: string
  ): Promise<boolean> {
    try {
      // executeOwnerAction을 통해 처리됨
      return true;
    } catch (error) {
      console.error('좌석 상태 변경 실패:', error);
      throw error;
    }
  }

  /**
   * 전체 좌석 초기화
   */
  async resetAllSeats(seatIds: string[]): Promise<void> {
    try {
      // executeOwnerAction을 통해 일괄 처리됨
    } catch (error) {
      console.error('전체 좌석 초기화 실패:', error);
      throw error;
    }
  }
}

/**
 * SeatManagementRepository 싱글톤 인스턴스
 */
export const seatManagementRepository = new SeatManagementRepository();
